import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// HIPAA §164.312(a)(2)(iii) automatic logoff — sign out after 15 minutes idle.
const IDLE_MS = 15 * 60 * 1000;

export default function SessionTimeout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const timer = useRef(null);

  useEffect(() => {
    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        await logout();
        toast.message("Signed out due to inactivity", {
          description: "For your security, please sign in again.",
        });
        navigate("/login", { replace: true });
      }, IDLE_MS);
    };
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [logout, navigate]);

  return null;
}
